import { render, staticRenderFns } from "./ReactiveToItemsCarousel.vue?vue&type=template&id=1ccd1edb&lang=pug"
import script from "./ReactiveToItemsCarousel.vue?vue&type=script&lang=js"
export * from "./ReactiveToItemsCarousel.vue?vue&type=script&lang=js"
import style0 from "./ReactiveToItemsCarousel.vue?vue&type=style&index=0&id=1ccd1edb&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports